import type { CiPipeline, CiPipelinesApi, CiRun, TriggerCiOptions } from './CiPipelinesApi';

const MOCK_PIPELINES: CiPipeline[] = [
  {
    id: 'ci/trigger-bootstrap-do-release',
    label: 'Bootstrap Release Params',
    description: '[MOCK] Update do-release default parameters for lower envs.',
    template: 'trigger-bootstrap-do-release',
    namespace: 'ci',
    params: [],
  },
  {
    id: 'ci/trigger-do-release',
    label: 'Trigger Do-Release',
    description: '[MOCK] Run do-release pipeline for lower envs.',
    template: 'trigger-do-release',
    namespace: 'ci',
    params: [],
  },
  {
    id: 'ci/deki-build-pipeline-web',
    label: 'Deki Web',
    description: '[MOCK] mindtouch-web / httpd / node-services images.',
    template: 'deki-build-pipeline-web',
    namespace: 'ci',
    params: [],
  },
];

const MOCK_RUNS: CiRun[] = [
  {
    workflowName: 'trigger-do-release-mock-abc12',
    namespace: 'ci',
    uid: 'mock-uid-001',
    phase: 'Succeeded',
    template: 'trigger-do-release',
    startedAt: new Date(Date.now() - 3600_000).toISOString(),
    finishedAt: new Date(Date.now() - 1800_000).toISOString(),
  },
  {
    workflowName: 'trigger-bootstrap-do-release-mock-def34',
    namespace: 'ci',
    uid: 'mock-uid-002',
    phase: 'Succeeded',
    template: 'trigger-bootstrap-do-release',
    startedAt: new Date(Date.now() - 7200_000).toISOString(),
    finishedAt: new Date(Date.now() - 6000_000).toISOString(),
  },
];

export class CiPipelinesClientMock implements CiPipelinesApi {
  async listPipelines(): Promise<CiPipeline[]> {
    return MOCK_PIPELINES;
  }

  async listRuns(): Promise<CiRun[]> {
    return MOCK_RUNS;
  }

  async triggerBuild(opts: TriggerCiOptions): Promise<{ namespace: string; name: string }> {
    await new Promise(r => setTimeout(r, 1200));
    const name = `${opts.pipeline.template}-mock-${Math.random().toString(36).slice(2, 7)}`;
    const ns = opts.pipeline.namespace ?? 'ci';
    // eslint-disable-next-line no-console
    console.log('[CiPipelinesClientMock] triggerBuild', { pipeline: opts.pipeline.id, ns, name, parameters: opts.parameters });
    return { namespace: ns, name };
  }
}
